export const objectDeepClone = (object: object) => {
    return JSON.parse(JSON.stringify(object));
}